


export default function setDuskAttributes(
  elem: HTMLElement,
  value: string
): void {
  elem.setAttribute('dusk', value)
}
